import { render } from "./pokemonInfo.vue?vue&type=template&id=3ed5710c&scoped=true"
import script from "./pokemonInfo.vue?vue&type=script&lang=js"
export * from "./pokemonInfo.vue?vue&type=script&lang=js"

import "./pokemonInfo.vue?vue&type=style&index=0&id=3ed5710c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Eric\\Desktop\\WEB\\apichu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed5710c"]])

export default __exports__